import { createContext, useContext } from 'react'

/* The toast context and the hook that reads it, kept apart from Toast.tsx —
   a module that exports both a component and a plain value breaks fast
   refresh, the same reason data/site.ts and the animation helpers live in
   files of their own. */

export type ToastTone = 'success' | 'error' | 'info'

export type Toast = {
  id: number
  tone: ToastTone
  title: string
  body?: string
}

export type ToastApi = {
  toast: (toast: Omit<Toast, 'id'>) => void
  dismiss: (id: number) => void
}

export const ToastContext = createContext<ToastApi | null>(null)

/** Raise a toast from anywhere under <ToastProvider>. */
export function useToast() {
  const context = useContext(ToastContext)
  if (!context) throw new Error('useToast must be used inside <ToastProvider>')
  return context
}
